/* global debounce, windowWidth, breakpointMd, slideUp, slideDown */

window.addEventListener('spectoCmsContentLoaded', () => {
  window.addEventListener('load', () => {
    const tabModules = document.querySelectorAll('.tab');

    tabModules.forEach((tabModule) => {
      const navTabLink = tabModule.querySelectorAll('[data-tablink]');
      const tabCards = tabModule.querySelectorAll('[data-tabcard]');

      const setTabHeight = (element, wrapper) => {
        wrapper.style.height = `${element.clientHeight}px`;

        const images = element.querySelectorAll('img');
        images.forEach((img) => {
          img.addEventListener('load', () => {
            wrapper.style.height = `${element.clientHeight}px`;
          });
        });
      };

      // Add height to active tab
      const activeTabHeight = () => {
        if (injection.windowWidth() > injection.breakpointMd) {
          const activeTabContent = tabModule.querySelectorAll('.tab__content.is-active');
          activeTabContent.forEach((element) => {
            const tabNavParent = element.closest('.tab');
            const tabContentWrapper = tabNavParent.querySelector('[data-tab-wrapper]');
            setTabHeight(element, tabContentWrapper);
          });
        }
      };

      const removeIsActive = (elements) => {
        elements.forEach((el) => el.classList.remove('is-active'));
      };

      // Close tab content
      const closeTabContents = (tabNavParent) => {
        const tabContentElems = tabNavParent.querySelectorAll('[data-tab-content]');
        removeIsActive(navTabLink);
        removeIsActive(tabCards);
        removeIsActive(tabContentElems);
      };

      // Close tab content for mobile
      const closeTabMobile = () => {
        tabModule.querySelectorAll('.tab__content').forEach((elem) => {
          if (elem.classList.contains('is-active')) {
            elem.classList.remove('is-active');
            injection.slideUp(elem.querySelector('.tab__content-inner'), 300);
          }
        });
      };

      activeTabHeight();

      // Debounce the function to prevent multiple executions on resize event
      const debounceTabHeight = injection.debounce(() => {
        activeTabHeight();
      }, 500);

      window.onresize = function() {
        debounceTabHeight();
      };

      // Open specific tab
      navTabLink.forEach((el) => {
        el.addEventListener('click', () => {
          const tabNavParent = el.closest('.tab');
          const tabContentWrapper = tabNavParent.querySelector('[data-tab-wrapper]');

          if (injection.windowWidth() < injection.breakpointMd && !tabModule.classList.contains('tab--with-dropdown')) {
            const parentTabContent = el.closest('.tab__content');
            if (!parentTabContent.classList.contains('is-active')) {
              closeTabMobile();
              parentTabContent.classList.add('is-active');
              injection.slideDown(parentTabContent.querySelector('.tab__content-inner'), 300);
            } else {
              closeTabMobile();
            }
          } else {
            const tabName = el.getAttribute('data-tablink');
            const targetContent = tabModule.querySelector(`.tab__content.${tabName}`);

            closeTabContents(tabNavParent);
            targetContent.classList.add('is-active');
            setTabHeight(targetContent, tabContentWrapper);
            el.classList.add('is-active');
          }
        });
      });

      tabCards.forEach((tabCard) => {
        tabCard.addEventListener('click', () => {
          const cardName = tabCard.getAttribute('data-tabcard');
          const targetContent = tabModule.querySelector(`.tab__content.${cardName}`);
          const targetLink = tabModule.querySelector(`.tab__nav-link.${cardName}`);
          const targetWrapper = targetContent.closest('.tab__content-wrapper');

          closeTabContents(targetWrapper);

          targetContent.classList.add('is-active');
          targetLink.classList.add('is-active');

          setTabHeight(targetContent, targetWrapper);

          const targetPosition = targetContent.getBoundingClientRect().top + window.scrollY;
          const topPos = targetPosition - (injection.windowWidth() < injection.breakpointMd ? 80 : 160);
          window.scrollTo({
            top: topPos,
            behavior: 'smooth',
          });
        });
      });

      // **************************************************

      const tabModuleSearch = tabModule.querySelector('#tab-module__search');
      if (tabModuleSearch) {
        const list = tabModuleSearch.closest('.tab__nav').querySelector('ul');

        const toggleActive = (add) => {
          tabModuleSearch.classList.toggle('is-active', add);
          list.classList.toggle('is-active', add);

          if (!add) {
            tabModuleSearch.blur();
          }
        };

        tabModuleSearch.addEventListener('focus', () => {
          toggleActive(true);
        });

        document.addEventListener('click', (event) => {
          if (!list.contains(event.target) && !tabModuleSearch.contains(event.target)) {
            toggleActive(false);
          }
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            toggleActive(false);
          }
        });
      }
    });
  });
});
